import cropHistoryReducer from './cropHistoryReducer'

const cropHistoryReducers = {
    cropHistory: cropHistoryReducer
}

export default cropHistoryReducers;